import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ColorPickerEditor from 'common/components/ColorPicker';
import { setFormButtonColorDefault, setFormButtonColorHover } from 'common/entities/form/styleConfiguration/actions';
import {
    DEFAULT_BUTTON_BACKGROUND_COLOR,
    DEFAULT_BUTTON_BACKGROUND_COLOR_HOVER,
} from 'common/entities/form/styleConfiguration/defaultValues';
import { getFormButtonColors } from 'common/entities/form/styleConfiguration/selectors';
import { getDefaultStyle, styleShapePropTypes } from 'common/entities/form/styleConfiguration/utils';
import { getColors } from 'common/entities/color/selectors';
import { getFormId } from '../../../../selectors';

import { COLOR_PICKER_DEFAULT, COLOR_PICKER_HOVER } from '../../../../constants/formStyleLabels';

import { BUTTON_QA } from '../../../../utils/qaIdConstants';

const ButtonBackgroundPanel = ({ formId, defaultColor, hoverColor, colorList, ...props }) => (
    <ColorPickerEditor
        colorList={colorList}
        firstColorLabel={COLOR_PICKER_DEFAULT}
        secondColorLabel={COLOR_PICKER_HOVER}
        firstColor={defaultColor}
        secondColor={hoverColor}
        changeFirstColor={(id) => props.setFormButtonColorDefault(formId, id)}
        changeSecondColor={(id) => props.setFormButtonColorHover(formId, id)}
        qaId={BUTTON_QA}
    />
);

ButtonBackgroundPanel.propTypes = {
    defaultColor: styleShapePropTypes,
    hoverColor: styleShapePropTypes,
    formId: PropTypes.string.isRequired,
    colorList: PropTypes.arrayOf(PropTypes.object).isRequired,
    setFormButtonColorDefault: PropTypes.func.isRequired,
    setFormButtonColorHover: PropTypes.func.isRequired,
};

ButtonBackgroundPanel.defaultProps = {
    defaultColor: getDefaultStyle(DEFAULT_BUTTON_BACKGROUND_COLOR),
    hoverColor: getDefaultStyle(DEFAULT_BUTTON_BACKGROUND_COLOR_HOVER),
};

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const colorList = getColors(state);
    const { default: defaultColor, hover: hoverColor } = getFormButtonColors(state, formId);

    return {
        formId,
        defaultColor,
        hoverColor,
        colorList,
    };
};

const mapDispatchToProps = {
    setFormButtonColorDefault,
    setFormButtonColorHover,
};

export default connect(mapStateToProps, mapDispatchToProps)(ButtonBackgroundPanel);
